
import React, { useState, forwardRef, useRef } from 'react';
import {
    DialogContent, DialogTitle, Dialog, Paper, TextField, Box, Grid, Typography, TableCell, TableContainer,
    Table, TableHead, Button, IconButton, TableRow, TableBody, Accordion, AccordionDetails,
} from '@mui/material';
import { v4 as uuidv4 } from "uuid";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from '@iconify/react';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import EditIcon from '@mui/icons-material/Edit';
import ReactToPrint, { PrintContextConsumer, useReactToPrint } from "react-to-print";
// import PurchaseEntryPrint from './PurchaseEntryPrint';
import { BootstrapDialog, BootstrapDialogTitle } from '../../reusableComponent/BootstrapDialog'
import { StyledTableCell, StyledTableRow } from '../../reusableComponent/StyledTable';
import ItemAdd from './ItemAdd';
import styles from '.././../../styles.module.css';


const ItemDetails = (props) => {
    const login_details = sessionStorage.getItem('loginUser');
    const userInfo = JSON.parse(login_details);

    const detailsView = props.details;
    const [open, setOpen] = useState(false)
    const dateConversion = (date) => {
        var today = new Date(date);
        var dd = String(today.getDate()).padStart(2, "0");
        var mm = String(today.getMonth() + 1).padStart(2, "0");
        var yyyy = today.getFullYear();
        const convDate = dd + "/" + mm + "/" + yyyy;
        return convDate;
    };
    const handleClose = (event, reason) => {
        setOpen(false);
    };
    const handleClickOpenPopup = (info) => {
        // setInfo(info);
        setOpen(true);
    };
    const navigate = useNavigate()
    const navigateToAddEdit = (row) => {
        const state = {
            ...row,
        };
        navigate('/masters/add-item-masters', { state });
    };

    return (
        <>

            <Paper sx={{ boxShadow: 'none' }}>
                <Box>
                    <Grid container spacing={2} sx={{ mb: 2 }}>
                        <Grid item md={10}>
                            <Grid container spacing={1} sx={{ mt: 0 }}>
                                <Grid item xs={2} >
                                    <Typography className={`${styles.detail_lable}`}>Item Name</Typography>
                                </Grid>
                                <Grid item xs={0.4} >
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`} >{detailsView.itemName}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography className={`${styles.detail_lable}`}>Item Type</Typography>
                                </Grid>
                                <Grid item xs={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`}>{detailsView.itemType}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography className={`${styles.detail_lable}`}>Category</Typography>
                                </Grid>
                                <Grid item xs={0.4} >
                                    <Typography className={`${styles.detail_lable}`}>:</Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`}>{detailsView.category}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography className={`${styles.detail_lable}`}>Item Code</Typography>
                                </Grid>
                                <Grid item xs={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {(detailsView.itemCode)}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography className={`${styles.detail_lable}`}>Item Description</Typography>
                                </Grid>
                                <Grid item xs={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`}>{detailsView.itemDescription}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography className={`${styles.detail_lable}`}>Bin No</Typography>
                                </Grid>
                                <Grid item xs={0.4} >
                                    <Typography className={`${styles.detail_lable}`}>:</Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {(detailsView.binNumber)}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography className={`${styles.detail_lable}`}>Unit Name</Typography>
                                </Grid>
                                <Grid item xs={0.4} >
                                    <Typography className={`${styles.detail_lable}`}>:</Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`}>{detailsView.unit}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography className={`${styles.detail_lable}`}>Rate</Typography>
                                </Grid>
                                <Grid item xs={0.4} >
                                    <Typography className={`${styles.detail_lable}`}>:</Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {parseFloat(detailsView.rate).toFixed(2)}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography className={`${styles.detail_lable}`}>MOQ</Typography>
                                </Grid>
                                <Grid item xs={0.4} >
                                    <Typography className={`${styles.detail_lable}`}>:</Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {(detailsView.moq)}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography className={`${styles.detail_lable}`}>HSN Code</Typography>
                                </Grid>
                                <Grid item xs={0.4} >
                                    <Typography className={`${styles.detail_lable}`}>:</Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {(detailsView.hsnCode)}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography className={`${styles.detail_lable}`}>GST</Typography>
                                </Grid>
                                <Grid item xs={0.4} >
                                    <Typography className={`${styles.detail_lable}`}>:</Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {(detailsView.gst)}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography className={`${styles.detail_lable}`}>Opening Stock</Typography>
                                </Grid>
                                <Grid item xs={0.4} >
                                    <Typography className={`${styles.detail_lable}`}>:</Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {(detailsView.openingStock)}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography className={`${styles.detail_lable}`}>Minimum Stock</Typography>
                                </Grid>
                                <Grid item xs={0.4} >
                                    <Typography className={`${styles.detail_lable}`}>:</Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {(detailsView.minimumStock)}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography className={`${styles.detail_lable}`}>Maximum Stock</Typography>
                                </Grid>
                                <Grid item xs={0.4} >
                                    <Typography className={`${styles.detail_lable}`}>:</Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {(detailsView.maximumStock)}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography className={`${styles.detail_lable}`}>Lead Time</Typography>
                                </Grid>
                                <Grid item xs={0.4} >
                                    <Typography className={`${styles.detail_lable}`}>:</Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {(detailsView.leadTime)}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography className={`${styles.detail_lable}`}>Low Stock Alert</Typography>
                                </Grid>
                                <Grid item xs={0.4} >
                                    <Typography className={`${styles.detail_lable}`}>:</Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {(detailsView.lowStockAlert)}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item md={2}>
                            <Box >
                                <Grid container spacing={0} >
                                    <Grid item md={12} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                                        <Box sx={{ marginBottom: '6px' }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'right', }}>
                                                <EditIcon style={{ float: 'left', fontSize: '20px', cursor: 'pointer' }} onClick={() => navigateToAddEdit(detailsView)} />
                                            </Box>
                                            < Box >
                                                <Icon icon="clarity:email-line" width="19" height="19" color="red" style={{}} />
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Paper>
            <BootstrapDialog
                PaperProps={{
                    sx: {
                        maxWidth: "85%",
                        maxHeight: 600,
                        minWidth: "30%",
                        minHeight: 120
                    }
                }}
                onClose={handleClose}
                open={open}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose} >
                    Update Item
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <ItemAdd handleCloseDialog={handleClose} details={detailsView} />
                </DialogContent>
            </BootstrapDialog>
        </>
    )
}
export default ItemDetails;